import React from 'react';

export interface BottomNavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  badge?: number | string;
  onClick?: () => void;
}

export interface BottomNavProps {
  items: BottomNavItem[];
  activeId: string;
  onChange: (id: string) => void;
  className?: string;
}

export const BottomNav: React.FC<BottomNavProps> = ({
  items,
  activeId,
  onChange,
  className = '',
}) => {
  return (
    <nav
      className={`bottom-nav ${className}`}
      role="navigation"
      aria-label="Navegação principal"
    >
      {items.map((item) => {
        const isActive = activeId === item.id;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-label={item.label}
            onClick={() => onChange(item.id)}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="bottom-nav-icon">
              {isActive && item.activeIcon ? item.activeIcon : item.icon}
            </span>
            <span className="font-label-sm">{item.label}</span>
            {item.badge && (
              <span
                className={`
                  absolute -top-1 -right-1 min-w-5 h-5
                  rounded-full bg-error text-on-error
                  font-label-sm text-center px-1
                  flex items-center justify-center
                `}
              >
                {item.badge}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
};